import { render, staticRenderFns } from "./EcButton.vue?vue&type=template&id=13b112ca"
import script from "./EcButton.vue?vue&type=script&lang=js"
export * from "./EcButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports